/**
 * Icônes métier complètes (inspirées Leboncoin / Marketplace)
 * → utilisées par la recherche IconPicker
 * → compatibles Bootstrap Icons
 * → orientées informations clés
 */
export const BOOTSTRAP_ICONS = [

  /* ================= VEHICULES ================= */
  { label: "Marque", icon: "tag", keywords: ["marque", "brand"] },
  { label: "Modèle", icon: "car-front", keywords: ["modele", "model"] },
  { label: "Année", icon: "calendar", keywords: ["annee", "year"] },
  { label: "Kilométrage", icon: "speedometer2", keywords: ["kilometrage", "km", "compteur"] },
  { label: "Carburant", icon: "fuel-pump", keywords: ["carburant", "essence", "diesel", "hybride", "electrique"] },
  { label: "Boîte de vitesse", icon: "gear", keywords: ["boite", "vitesse", "manuelle", "automatique"] },
  { label: "Puissance", icon: "lightning-charge", keywords: ["puissance", "chevaux", "cv"] },
  { label: "Couleur", icon: "palette", keywords: ["couleur", "color"] },
  { label: "Nombre de portes", icon: "door-closed", keywords: ["portes", "door"] },
  { label: "État du véhicule", icon: "check-circle", keywords: ["etat", "occasion", "neuf"] },
  { label: "Immatriculation", icon: "file-earmark-text", keywords: ["immatriculation", "carte grise"] },
  { label: "Garantie", icon: "shield-check", keywords: ["garantie", "warranty"] },

  /* ================= IMMOBILIER ================= */
  { label: "Prix", icon: "currency-euro", keywords: ["prix", "price", "budget"] },
  { label: "Surface", icon: "rulers", keywords: ["surface", "m2", "taille"] },
  { label: "Pièces", icon: "door-open", keywords: ["pieces", "rooms"] },
  { label: "Chambres", icon: "house-door", keywords: ["chambre", "bedroom"] },
  { label: "Salle de bain", icon: "droplet", keywords: ["salle de bain", "bathroom"] },
  { label: "Ville", icon: "geo-alt", keywords: ["ville", "city", "localisation"] },
  { label: "Quartier", icon: "map", keywords: ["quartier", "zone"] },
  { label: "Meublé", icon: "house-check", keywords: ["meuble", "furnished"] },
  { label: "Étage", icon: "layers", keywords: ["etage", "floor"] },
  { label: "Ascenseur", icon: "arrow-up-square", keywords: ["ascenseur", "lift"] },
  { label: "Parking", icon: "p-square", keywords: ["parking", "garage"] },
  { label: "Balcon / Terrasse", icon: "bounding-box", keywords: ["balcon", "terrasse"] },
  { label: "Type de bien", icon: "house", keywords: ["maison", "appartement", "villa"] },

  /* ================= EMPLOI ================= */
  { label: "Poste", icon: "briefcase", keywords: ["poste", "job", "metier"] },
  { label: "Type de contrat", icon: "file-earmark-text", keywords: ["contrat", "cdi", "cdd", "freelance"] },
  { label: "Salaire", icon: "cash", keywords: ["salaire", "paie", "remuneration"] },
  { label: "Horaires", icon: "clock", keywords: ["horaire", "temps"] },
  { label: "Expérience", icon: "bar-chart", keywords: ["experience", "anciennete"] },
  { label: "Télétravail", icon: "laptop", keywords: ["teletravail", "remote"] },
  { label: "Localisation", icon: "geo", keywords: ["lieu", "ville"] },

  /* ================= MULTIMEDIA ================= */
  { label: "Marque", icon: "tag", keywords: ["marque", "brand"] },
  { label: "État", icon: "check-circle", keywords: ["etat", "neuf", "occasion"] },
  { label: "Stockage", icon: "hdd", keywords: ["stockage", "memoire", "ssd"] },
  { label: "Écran", icon: "aspect-ratio", keywords: ["ecran", "taille"] },
  { label: "Système", icon: "cpu", keywords: ["systeme", "os"] },
  { label: "Connectivité", icon: "wifi", keywords: ["wifi", "bluetooth"] },

  /* ================= MAISON & JARDIN ================= */
  { label: "Type d'objet", icon: "box", keywords: ["objet", "type"] },
  { label: "Dimensions", icon: "arrows-expand", keywords: ["dimension", "taille"] },
  { label: "Poids", icon: "speedometer", keywords: ["poids", "kg"] },
  { label: "Matériau", icon: "layers", keywords: ["materiau", "bois", "metal"] },
  { label: "Couleur", icon: "palette", keywords: ["couleur"] },

  /* ================= SERVICES ================= */
  { label: "Type de service", icon: "tools", keywords: ["service", "prestation"] },
  { label: "Tarif", icon: "currency-euro", keywords: ["tarif", "prix"] },
  { label: "Disponibilité", icon: "calendar-check", keywords: ["disponibilite", "date"] },
  { label: "Zone d’intervention", icon: "map", keywords: ["zone", "intervention"] },

  /* ================= LOISIRS ================= */
  { label: "Type", icon: "star", keywords: ["type"] },
  { label: "Âge recommandé", icon: "person", keywords: ["age"] },
  { label: "État", icon: "check-circle", keywords: ["etat"] },

  /* ================= ANIMAUX ================= */
  { label: "Espèce", icon: "bug", keywords: ["animal", "espece"] },
  { label: "Race", icon: "award", keywords: ["race"] },
  { label: "Âge", icon: "calendar", keywords: ["age"] },
  { label: "Vacciné", icon: "shield-check", keywords: ["vaccine", "vaccin"] },

  /* ================= GENERIQUE ================= */
  { label: "Téléphone", icon: "telephone", keywords: ["telephone", "phone"] },
  { label: "Email", icon: "envelope", keywords: ["email", "mail"] },
  { label: "Date", icon: "calendar", keywords: ["date"] },
  { label: "Description", icon: "file-text", keywords: ["description", "texte"] },
  { label: "Image", icon: "image", keywords: ["image", "photo"] },
  { label: "Localisation", icon: "map", keywords: ["localisation", "position"] },
  { label: "Référence", icon: "hash", keywords: ["reference", "code"] },
  { label: "Statut", icon: "info-circle", keywords: ["statut", "etat"] }
];
